import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getFanDiscountsRpcContract = rpcContract({
  name: "get-fan-discounts",
  paramsSchema: v.object({
    limit: v.optional(v.pipe(v.number(), v.minValue(1), v.maxValue(100)), 20),
    offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
    search: v.optional(v.string()),
  }),
  resultSchema: v.object({
    discounts: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        url: v.string(),
        teaser: v.nullable(v.string()),
        code: v.nullable(v.string()),
        thumbnail: v.nullable(v.string()),
        has_discount: v.boolean(),
        exclusive: v.boolean(),
        priority: v.nullable(v.number()),
        end_date: v.nullable(v.string()),
        contentTier: v.optional(v.union([v.literal("free"), v.literal("premium")])),
        hasAccess: v.boolean(),
        oneTimeProduct: v.optional(
          v.object({
            id: v.string(),
            priceCents: v.number(),
          }),
        ),
        promotion_file: v.nullable(
          v.object({
            id: v.string(),
            path: v.string(),
            thumbnail_path: v.nullable(v.string()),
            mime_type: v.string(),
          }),
        ),
        promotion_brand: v.nullable(
          v.object({
            id: v.string(),
            name: v.string(),
            thumbnail: v.nullable(v.string()),
          }),
        ),
        creator: v.nullable(
          v.object({
            id: v.string(),
            handle: v.nullable(v.string()),
            first_name: v.string(),
            last_name: v.string(),
            email: v.nullable(v.string()),
            profile_image: v.nullable(v.string()),
            avatar_file: v.nullable(
              v.object({
                id: v.string(),
                path: v.string(),
                thumbnail_path: v.nullable(v.string()),
              }),
            ),
          }),
        ),
      }),
    ),
    totalCount: v.number(),
    hasMore: v.boolean(),
  }),
});

export type GetFanDiscountsParams = v.InferOutput<(typeof getFanDiscountsRpcContract)["paramsSchema"]>;
export type GetFanDiscountsResult = v.InferOutput<(typeof getFanDiscountsRpcContract)["resultSchema"]>;
export type FanDiscount = v.InferOutput<(typeof getFanDiscountsRpcContract)["resultSchema"]>["discounts"][0];
